export const PLANS_REQUESTED = 'PLANS_REQUESTED'
export const PLANS_RECEIVED = 'PLANS_RECEIVED'

export const PLAN_RANK_SELECTED = 'PLAN_RANK_SELECTED'
export const PLAN_RANKS_REQUESTED = 'PLAN_RANKS_REQUESTED'
export const PLAN_RANKS_RECEIVED = 'PLAN_RANKS_RECEIVED'

export const PLAN_COMPARE_ADDED = 'PLAN_COMPARE_ADDED'
export const PLAN_COMPARE_REMOVED = 'PLAN_COMPARE_REMOVED'
export const PLAN_COMPARE_CLEARED = 'PLAN_COMPARE_CLEARED'

export const PLAN_SAVE_ADDED = 'PLAN_SAVE_ADDED'
export const PLAN_SAVE_REMOVED = 'PLAN_SAVE_REMOVED'

export const PLAN_SELECTED = 'PLAN_SELECTED'

export const PLAN_PRICE_DIALOG_CLOSED = 'PLAN_PRICE_DIALOG_CLOSED'
export const CHECK_IF_PLAN_PRICE_CHANGED = 'CHECK_IF_PLAN_PRICE_CHANGED'
export const PLAN_PRICE_CHANGED = 'PLAN_PRICE_CHANGED'

export const SHARE_QUOTE_REQUESTED = 'SHARE_QUOTE_REQUESTED'
export const SHARE_QUOTE_RECEIVED = 'SHARE_QUOTE_RECEIVED'
